document.querySelectorAll(".mix-section").forEach(section => {

    const carousel = section.querySelector(".mix-products");
    const prev = section.querySelector(".carousel-prev");
    const next = section.querySelector(".carousel-next");

    prev?.addEventListener("click", () => {
        carousel.scrollBy({
            left: -carousel.clientWidth,
            behavior: "smooth"
        });
    });

    next?.addEventListener("click", () => {
        carousel.scrollBy({
            left: carousel.clientWidth,
            behavior: "smooth"
        });
    });

});